import { PDFDesignLayerType } from '../../../../types'

export interface LayerPreviewProps {
  typename: keyof typeof PDFDesignLayerType
  globalId: string | undefined | false
  projectLayerIds: number[] | undefined
}

export const LayerPreviewType = {
  ConcretePlacement: { name: 'Concrete Placement' },
  AsphaltPlacement: { name: 'Asphalt Placement' },
  Lot: { name: 'Lot' },
  DailyInspectionControlPoint: { name: 'Control Point' },
  DailyInspectionPunchList: { name: 'Punch List' },
  DailyInspectionInspection: { name: 'Inspection' },
} as const
